import React, { memo, useEffect, useRef, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { Controller, useForm } from 'react-hook-form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
//components
import ConfirmationBox from 'components/common/Message/ConfirmationBox/ConfirmationBox';
import InformationBox from 'components/common/Message/InformationBox/InformationBox';
import AddSite from 'pages/Sites/ManageSite/AddSite';

//icons
import { BsExclamationCircleFill, BsPlusLg } from 'react-icons/bs';
//redux
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import { onAddSite, setNewSiteData } from 'redux/pages/Administration/Site/siteSlice';
import { onCopyOrMoveSystemReports, onGetContract, onGetCustomers, onGetSites,addCustomerSitemap, setcustomerSiteMap } from 'redux/pages/Manage/Tools/ToolSlice';

type FormData = {
    fromCustomerSearchCriteria: string;
    fromSiteId: string;
    fromContractId: string;
    toCustomerSearchCriteria: any;
    toSiteId: string;
};

interface MoveAllSystemsPropType {
    systemType?: string;
}
const MoveAllSystems: React.FC<MoveAllSystemsPropType> = (props) => {
    const { systemType } = props;

    const [fromSiteList, setFromSiteList] = useState([]);
    const [toSiteList, setToSiteList] = useState<any>([]);
    const [fromContractList, setFromContractList] = useState([]);
    const [filterFromCustomers, setFilterFromCustomers] = useState<any>(null);
    const [filterToCustomers, setFilterToCustomers] = useState<any>(null);
    const [displayInfoModal, setDisplayInfoModal] = useState(false);
    const [message, setMessage] = useState("");
    const [showAddSite, setShowAddSite] = useState(false);
    const [displayConfirmModal, setDisplayConfirmModal] = useState(false);
    //case of submitting 
    const [bodyInfo, setBodyInfo] = useState<any>(null);
    const [targetPage, setTargetPage] = useState(1);
    const [statusMessage, setStatusMessage] = useState("");
    const [systemList, setSystemList] = useState<any>(null);
    const [isCopied, setIsCopied] = useState(false);
    const [showSystemDuplication, setShowSystemDuplication] = useState(false);
    const [showError, setShowError] = useState(false);
    const addRef = useRef<any>(null);

    const dispatch = useDispatch<any>();
    const newSite = useAppSelector((state) => state.site.newSite);
    const customerSiteMap = useAppSelector((state) => state.tool.customerSiteMap);

    const {
        control,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
    } = useForm<FormData>({
        defaultValues: {
            fromCustomerSearchCriteria: "",
            fromSiteId: "",
            fromContractId: "",
            toCustomerSearchCriteria: "",
            toSiteId: "",
        },
    });

    useEffect(() => {
        if (newSite) { 
             let data = JSON.parse(JSON.stringify(newSite));            
            const toCustomer: any = watch("toCustomerSearchCriteria");
            const body={
                UniqueTargetCustomerId:   toCustomer?.uniqueCustomerId,
                UniqueTargetSiteId: `${data.uniqueSiteId}`
            }
            dispatch (addCustomerSitemap(body))
        }
    }, [newSite])

    useEffect(() => {
        if (newSite && customerSiteMap?.message) {
            let data = JSON.parse(JSON.stringify(newSite));
            data.siteName = `${data.siteName} (${data.siteNumber})`;
            dispatch(setNewSiteData(""));
            toSiteList.push(data);
            const ascDatas = [...toSiteList].sort((a, b) => a.siteName - b.siteName);
            setToSiteList(ascDatas);
            dispatch(setcustomerSiteMap(""));
        }
    }, [customerSiteMap])

    useEffect(() => {
        if (statusMessage) {
            setDisplayConfirmModal(true);
        }
    }, [statusMessage])

    useEffect(() => {
        if (isCopied) {
            reset();
            setIsCopied(false);
            setStatusMessage("");
            setTargetPage(1);
            setSystemList(null);
            setDisplayConfirmModal(false);
            setShowSystemDuplication(false);
            setFilterFromCustomers(null);
            setFilterToCustomers(null);
            setFromSiteList([]);
            setToSiteList([]);
            setFromContractList([]);
        }
    }, [isCopied])

    useEffect(() => {
        if (targetPage === 4) {
            setShowSystemDuplication(false);
        }
    }, [targetPage])

    const searchFromCustomer = (event) => {
        setTimeout(() => {
            const body = {
                uniqueBusinessZoneId: null,
                searchText: event?.query,
                uniqueSourceCustomerId: null,
            }
            dispatch(onGetCustomers(null, body, setFilterFromCustomers));
        }, 250);
    };

    const searchToCustomer = (event) => {
        const customer: any = watch("fromCustomerSearchCriteria");
        if (!customer) {
            setDisplayInfoModal(true);
            setMessage("Select a From Customer");
            return;
        }
        setTimeout(() => {
            const body = {
                uniqueBusinessZoneId: null,
                searchText: event?.query,
                uniqueSourceCustomerId: customer?.uniqueCustomerId,
            }
            dispatch(onGetCustomers(null, body, setFilterToCustomers));
        }, 250);
    }

    const copyData = (data) => {
        if (!data?.fromCustomerSearchCriteria?.uniqueCustomerId) {
            setDisplayInfoModal(true);
            setMessage("Select a From Customer");
            return;
        }
        if (!data?.toCustomerSearchCriteria?.uniqueCustomerId) {
            setDisplayInfoModal(true);
            setMessage("Select a To Customer");
            return;
        }
        if (data?.fromSiteId !== data?.toSiteId) {
            const body = {
                uniqueSourceCustomerId: data?.fromCustomerSearchCriteria?.uniqueCustomerId,
                uniqueSourceContractId: data?.fromContractId,
                uniqueSourceSiteId: data?.fromSiteId ? data?.fromSiteId : '0',
                uniqueTargetCustomerId: data?.toCustomerSearchCriteria?.uniqueCustomerId,
                uniqueTargetSiteId: data?.toSiteId ? data?.toSiteId : '0',
                keepSourceData: false,
                systemData: systemType === "system" ? "SELECTED_SYSTEM" : "ALL_SYSTEM",
                system: systemList,
                pageTarget: targetPage,
            }

            dispatch(onCopyOrMoveSystemReports(body, setStatusMessage, setTargetPage, setSystemList, setIsCopied, setMessage, setDisplayInfoModal));
            setBodyInfo(body);
        } else {
            setMessage("Source Site and Destination Site are same, cannot be moved");
            setDisplayInfoModal(true);
        }
    };

    const addSite = () => {
        const fromCustomer: any = watch("fromCustomerSearchCriteria");
        const toCustomer: any = watch("toCustomerSearchCriteria");
        if (!fromCustomer?.uniqueCustomerId) {
            setDisplayInfoModal(true);
            setMessage("Select a From Customer");
            return;
        }
        if (!toCustomer?.uniqueCustomerId) {
            setDisplayInfoModal(true);
            setMessage("Select a To Customer");
            return;
        }
        setShowAddSite(true);
    }

    const confirmedCopy = () => {
        if (targetPage === 3) {
            setShowSystemDuplication(true);
            setDisplayConfirmModal(false);
            return;
        }
        bodyInfo.system = systemList;
        bodyInfo.pageTarget = targetPage;
        setBodyInfo(bodyInfo);
        dispatch(onCopyOrMoveSystemReports(bodyInfo, setStatusMessage, setTargetPage, setSystemList, setIsCopied, setMessage, setDisplayInfoModal))
    }

    const onConfirmCancel = () => {
        setDisplayConfirmModal(false);
        setStatusMessage("");
        setTargetPage(1);
        setSystemList(null);
    }

    const onCancelSystem = () => {
        setStatusMessage("");
        setTargetPage(1);
        setSystemList(null);
        setShowSystemDuplication(false);
    }

    const onUpdateSystem = () => {
        if (targetPage === 3) {
            let isEmpty = false;
            systemList?.forEach(element => {
                if (!element?.uniqueSystemName)
                    isEmpty = true
            });
            if (isEmpty) {
                setShowError(true);
                return;
            }
        }
        const systems = systemList?.map(({ sourceSystemName, ...rest }: any) => {
            return rest;
        });
        bodyInfo.system = systems;
        bodyInfo.pageTarget = targetPage;
        dispatch(onCopyOrMoveSystemReports(bodyInfo, setStatusMessage, setTargetPage, setSystemList, setIsCopied, setMessage, setDisplayInfoModal))
        setBodyInfo(bodyInfo);
    }

    const onAddSiteClick = (submitData: any) => {
        submitData.uniqueTargetCustomerId = watch("toCustomerSearchCriteria")?.uniqueCustomerId;
        dispatch(
            onAddSite(
                submitData,
                setMessage,
                setDisplayInfoModal,
                setShowAddSite,
            )
        );
    };


    const getFormErrorMessage = (name) => {
        return (
            errors[name] && (
                <span className="tooltip-text">
                    <BsExclamationCircleFill />
                    {errors[name].message}
                </span>
            )
        );
    };

    const renderFooter = () => {
        return (
            <>
                <Button label="Cancel" onClick={onCancelSystem} className='cancel btn' />
                <Button label="Ok" className='save btn' onClick={onUpdateSystem} autoFocus />
            </>
        );
    }

    const editableTemplate = (rowData, columnDetails) => {

        return (
            <div className='custom-float-field'>
                <span className="p-float-label ">
                    <InputText
                        id={rowData?.uniqueSystemId}
                        value={rowData?.uniqueSystemName}
                        onChange={(e: any) => {
                            systemList[columnDetails?.rowIndex]["uniqueSystemName"] = e.target.value;
                            setSystemList([...systemList]);
                        }}
                        className={`w-100 ${showError && rowData?.uniqueSystemName === "" ? 'p-invalid error-tooltip error' : ''}`}
                    />
                    <label htmlFor={rowData?.uniqueSystemId} className={"mandatory"}>
                        Destination System Name
                    </label>
                    {showError && rowData?.uniqueSystemName === "" &&
                        <span className="tooltip-text">
                            <BsExclamationCircleFill />
                            <span>Enter System Name</span>
                        </span>
                    }
                </span>
            </div>
        )
    }

    return (
        <div className="copy-system mt-3">
            <p className="title">
                <b>Move All Systems in a Contract</b>
            </p>
            <div className="send-recieve-items">
                <form onSubmit={handleSubmit(copyData)} ref={addRef}>
                    <div className="from box">
                        <span className="pb-2 pl-2">
                            <b>From</b>
                        </span>

                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="fromCustomerSearchCriteria"
                                    control={control}
                                    rules={{
                                        required: "Enter Customer Name",
                                    }}
                                    render={({ field, fieldState }) => (
                                        <AutoComplete
                                            id="fromCustomerSearchCriteria"
                                            value={field.value}
                                            className={classNames("w-100 error-tooltip", {
                                                error: fieldState.invalid,
                                            })}
                                            suggestions={filterFromCustomers}
                                            completeMethod={searchFromCustomer}
                                            onSelect={(e) => {
                                                const body = {
                                                    uniqueCustomerId: e.value.uniqueCustomerId,
                                                    uniqueBusinessZoneId: null,
                                                    searchText: "",
                                                    uniqueContractId: null,
                                                }
                                                setValue("fromSiteId", "");
                                                setFromSiteList([]);
                                                dispatch(onGetSites(null, body, setFromSiteList, false, setDisplayInfoModal, setMessage))
                                            }}
                                            field="customerName"
                                            onChange={(e) => field.onChange(e.value)}
                                            aria-label="Customers"
                                            dropdownAriaLabel="Select Customer"
                                        />
                                    )}
                                />
                                <label className="mandatory" htmlFor="fromCustomerSearchCriteria">
                                    Customer
                                </label>
                                {getFormErrorMessage("fromCustomerSearchCriteria")}
                            </span>
                        </div>

                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="fromSiteId"
                                    control={control}
                                    rules={{
                                        required: watch("fromCustomerSearchCriteria") ? "Select a Site" : "",
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            inputId="fromSiteId"
                                            className={classNames("w-100 error-tooltip", {
                                                error: fieldState.invalid,
                                            })}
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                const customer: any = watch("fromCustomerSearchCriteria");
                                                const body = {
                                                    uniqueCustomerId: customer?.uniqueCustomerId,
                                                    uniqueSiteId: e.value,
                                                    IsCopy: false,
                                                }
                                                setValue("fromContractId", "");
                                                setFromContractList([]);
                                                dispatch(onGetContract(body, setFromContractList, setDisplayInfoModal, setMessage))
                                            }}
                                            options={fromSiteList}
                                            optionLabel="siteName"
                                            optionValue="uniqueSiteId"
                                        />
                                    )}
                                />
                                <label className="mandatory" htmlFor="dropdown">
                                    Site
                                </label>
                                {getFormErrorMessage("fromSiteId")}
                            </span>
                        </div>

                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="fromContractId"
                                    control={control}
                                    rules={{
                                        required: watch("fromSiteId") ? "Select a Contract" : "",
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            inputId="fromContractId"
                                            className={classNames("w-100 error-tooltip", {
                                                error: fieldState.invalid,
                                            })}
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)}
                                            options={fromContractList}
                                            optionLabel="contractName"
                                            optionValue="uniqueContractId"
                                        />
                                    )}
                                />
                                <label className="mandatory" htmlFor="dropdown">
                                    Contract
                                </label>
                                {getFormErrorMessage("fromContractId")}
                            </span>
                        </div>

                    </div>
                    <div className="icon"></div>
                    <div className="to box">
                        <span className="pb-2 pl-2">
                            <b>To</b>
                        </span>

                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="toCustomerSearchCriteria"
                                    control={control}
                                    rules={{
                                        required: "Enter Customer Name",
                                    }}
                                    render={({ field, fieldState }) => (
                                        <AutoComplete
                                            id="toCustomerSearchCriteria"
                                            value={field.value}
                                            className={classNames("w-100 error-tooltip", {
                                                error: fieldState.invalid,
                                            })}
                                            suggestions={filterToCustomers}
                                            completeMethod={searchToCustomer}
                                            onSelect={(e) => {
                                                const body = {
                                                    uniqueCustomerId: e.value.uniqueCustomerId,
                                                    uniqueBusinessZoneId: null,
                                                    searchText: "",
                                                    uniqueContractId: null,
                                                }
                                                setValue("toSiteId", "");
                                                setToSiteList([]);
                                                dispatch(onGetSites(e?.value?.countryId, body, setToSiteList, false, setDisplayInfoModal, setMessage))
                                            }}
                                            field="customerName"
                                            onChange={(e) => field.onChange(e.value)}
                                            aria-label="Customers"
                                            dropdownAriaLabel="Select Customer"
                                        />
                                    )}
                                />
                                <label className="mandatory" htmlFor="toCustomerSearchCriteria">
                                    Customer
                                </label>
                                {getFormErrorMessage("toCustomerSearchCriteria")}
                            </span>
                        </div>

                        <div className="row px-2 align-items-center">
                            <div className="field col-11 md:col-2 mb-0">
                                <span className="p-float-label">
                                    <Controller
                                        name="toSiteId"
                                        control={control}
                                        rules={{
                                            required: watch("toCustomerSearchCriteria") ? "Select a Site" : "",
                                        }}
                                        render={({ field, fieldState }) => (
                                            <Dropdown
                                                inputId="toSiteId"
                                                className={classNames("w-100 error-tooltip", {
                                                    error: fieldState.invalid,
                                                })}
                                                {...field}
                                                value={field.value}
                                                onChange={(e) => field.onChange(e.value)}
                                                options={toSiteList}
                                                optionLabel="siteName"
                                                optionValue="uniqueSiteId"
                                            />
                                        )}
                                    />
                                    <label className="mandatory" htmlFor="toSiteId">
                                        Site
                                    </label>
                                    {getFormErrorMessage("toSiteId")}
                                </span>
                            </div>
                            <div className="field col-1 md:col-2 mb-0 p-0">
                                <span className="p-float-label action-btns">
                                    <div
                                        className="button-icon"
                                        onClick={() => addSite()}
                                    >
                                        <BsPlusLg className="icon" />
                                    </div>
                                </span>
                            </div>
                        </div>

                    </div>
                </form>

                <Button label="Move" className="btn mt-3" autoFocus onClick={() => addRef?.current?.requestSubmit()} />

                <InformationBox
                    showInfoModal={displayInfoModal}
                    setShowInfoModal={setDisplayInfoModal}
                    message={message}
                />
                <ConfirmationBox
                    showConfirmModal={displayConfirmModal}
                    setShowConfirmModal={onConfirmCancel}
                    confirmAction={confirmedCopy}
                    message={statusMessage}
                />
                {showAddSite && (
                    <AddSite
                        showModal={showAddSite}
                        setShowModal={setShowAddSite}
                        onAddSiteClick={(data) => onAddSiteClick(data)}
                    />)
                }
            </div>
            <Dialog
                header="System Name(s)"
                visible={showSystemDuplication}
                style={{ width: '35vw' }}
                footer={renderFooter()}
                onHide={onCancelSystem}
                className='s-modal'
            >
                <div>
                    {systemList?.length &&
                        <DataTable value={systemList} responsiveLayout="scroll">
                            <Column field="sourceSystemName" header="Source System Name"></Column>
                            <Column header="Destination System Name" body={editableTemplate}></Column>
                        </DataTable>
                    }
                </div>
            </Dialog>
        </div>
    )
}

export default memo(MoveAllSystems)